<h2 mat-dialog-title>{{ 'users.policyGroups.permissionGroup' | t }}</h2>
<mat-dialog-content class="mat-typography">
  <sn-form [fields]="formFields" [model]="formModel"></sn-form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button color="danger" mat-button mat-dialog-close>{{ 'common.cancel' | t }}</button>
  <button mat-button color="success" (click)="submit()">{{ 'common.save' | t }}</button>
</mat-dialog-actions>
